import { useState } from "react";
import { useApp } from "../context/AppContext";
import SeoCocoonView from "./SeoCocoonView";
import InterlinkingView from "./InterlinkingView";
import CocoonKeywordsMap from "./CocoonKeywordsMap";

const TABS = [
  { key: "visual", label: "Візуалізація", icon: "🌐" },
  { key: "impl", label: "Реалізація", icon: "🔗" },
  { key: "map", label: "Ключі та n-грами", icon: "📊" },
];

export default function SeoCocoonCombinedView() {
  const { dark, t, card, stitle, muted } = useApp();
  const [tab, setTab] = useState("visual");

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <h2 style={{ ...stitle, margin: 0 }}>SEO Кокон</h2>
          <p style={{ ...muted, margin: "4px 0 0", fontSize: 13 }}>Візуалізація графу посилань та реалізація перелінковки</p>
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {TABS.map(tb => (
          <button key={tb.key} onClick={() => setTab(tb.key)} style={{
            padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer",
            background: tab === tb.key ? "#6366f1" : dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
            color: tab === tb.key ? "#fff" : t.text,
            fontWeight: tab === tb.key ? 700 : 500, fontSize: 13, fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 6, transition: "all .15s",
          }}>
            <span>{tb.icon}</span> {tb.label}
          </button>
        ))}
      </div>
      {tab === "visual" && <SeoCocoonView />}
      {tab === "impl" && <InterlinkingView />}
      {tab === "map" && <CocoonKeywordsMap />}
    </div>
  );
}
